export default "__VITE_ASSET__c76eb3e5__"